// src/features/catalog/components/dashboard/dashboardFilter.ts
import type { Course } from '@/types/course'
import { courseCardStatus } from '@/components/catalog/CourseStatusChip'
import type { DashboardFilter } from './DashboardHeader'

/**
 * Single source of truth for the dashboard tab filter rules. Used for both the header
 * counts (Dashboard) and the visible list (DashboardCourseGrid) so they can't drift.
 *
 * Вкладка решает по тому же статусу, что чип на обложке (`courseCardStatus`):
 * «По ссылке» — тоже опубликованный курс, и проверка одного `isPublished`
 * пускала его во вкладку «В каталоге», а `isPublic === false` у черновика —
 * во вкладку «По ссылке».
 */
export const matchesDashboardFilter = (course: Course, filter: DashboardFilter): boolean => {
  const status = courseCardStatus(course)
  switch (filter) {
    case 'drafts':
      return status === 'draft'
    case 'published':
      return status === 'published'
    case 'link':
      return status === 'link'
    case 'all':
    default:
      return true
  }
}

/** Поиск по названию (оба языка) — тот же для списка и для счётчиков вкладок. */
export const matchesDashboardSearch = (course: Course, search: string): boolean => {
  const query = search.trim().toLowerCase()
  if (!query) return true
  return `${course.name ?? ''} ${course.nameEn ?? ''}`.toLowerCase().includes(query)
}
